/**
 *  CampaignCompare script file
 **/
import campaignsService from '@/api/campaignsService'
import channelService from '@/api/channelService'
import { CHANNEL_COLORS, CHANNEL_LABELS } from '@/utils/campaignOptions'

export default {
  name: 'CampaignCompare',
  mixins: [],
  components: {
    Tag: () => import('@/components/common/tag/Tag.vue'),
    CampaignCardCompare: () => import('@/components/campaign-card-compare/CampaignCardCompare.vue')
  },
  props: {},
  data () {
    return {
      items: [],
      type: null,
      channelSelector: [],
      loading: true
    }
  },
  computed: {
    campaignIds () {
      return (this.$route.params.campaignsid || '').split(',').slice(0, 3)
    },
    campaigns () {
      return this.items
    }
  },
  async mounted () {
    const campaigns = await campaignsService.getCampaignComparison({ ids: this.campaignIds })
    const data = this.items
    campaigns.forEach((c, idx) => {
      data[idx] = {
        campaign: c,
        channel: {}
      }
    })
    this.populateChannelsSelector()
    this.setChannel(this.channelSelector[0])
  },
  methods: {
    async setChannel (channel) {
      this.type = channel.id
      this.channelSelector = this.channelSelector.map(c => {
        c.active = channel.id === c.id
        return c
      })
      this.populateCampaignsChannels()
    },
    populateChannelsSelector () {
      const channels = {}
      const type = this.type
      this.items.forEach(c => {
        c.campaign.channels.forEach(ch => {
          if (!channels[ch.type]) {
            channels[ch.type] = {
              id: ch.type,
              label: CHANNEL_LABELS[ch.type],
              color: CHANNEL_COLORS[ch.type],
              text: '#ffffff',
              border: CHANNEL_COLORS[ch.type],
              active: false
            }
          }
        })
      })
      this.channelSelector = Object.keys(channels).map((k, idx) => {
        const ch = channels[k]
        ch.active = (!type && idx === 0) || (type === ch.id)
        return ch
      })
    },
    async populateCampaignsChannels () {
      this.loading = true
      const channels = []
      const type = this.type
      this.items.forEach((c) => {
        const channel = c.campaign.channels.find(c => c.type === type)
        channels.push(channel ? channel.id : undefined)
      })
      const p = channels.map((cId, idx) => {
        if (cId) {
          return this.getChannelStats(cId, type)
        } else {
          return Promise.resolve({})
        }
      })
      Promise.all(p).then(values => {
        values.forEach((val, index) => {
          this.items[index]['channel'] = this.parseChannelData(val, channels[index])
        })
        this.calculateRanking()
        this.items = [...this.items]
        setTimeout(() => { this.loading = false }, 100)
      })
    },
    async getChannelStats (channelID, type) {
      return channelService.getChannelStats(channelID, type)
    },
    parseChannelData (data, channelId) {
      const cId = channelId ? { id: channelId } : {}
      return { ...data, ...cId }
    },
    calculateRanking () {
      const channels = this.items.map(
        i => (i.campaign.channels.find(ch => ch.type === this.type) || { kpi: undefined }).kpi
      )
      let kpi = channels.find(kpi => kpi)
      let orderedRanking = []
      if (kpi) {
        kpi = kpi.toLowerCase()
        orderedRanking = [...this.items].sort((a, b) => {
          let mA = (a.channel.metrics || []).find(m => m.key === kpi)
          mA = mA ? mA.total : 0

          let mB = (b.channel.metrics || []).find(m => m.key === kpi)
          mB = mB ? mB.total : 0
          return mB - mA
        })
          .map(c => c.campaign.id)
      }
      this.items.forEach(i => {
        i.channel['ranking'] = Math.max(orderedRanking.indexOf(i.campaign.id) + 1, 1)
      })
    }
  }
}
